import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addTrendingMovies } from "../utils/movieSlice";
import axios from "axios";

const useTrendingMovies = () => {
  const dispatch = useDispatch();

  const trendingMovies = useSelector((store) => store.movies.trendingMovies);

  const url = "https://api.themoviedb.org/3/trending/movie/day";

  async function getTrendingAll() {
    try {
      const response = await axios.get(url, API_OPTIONS);
      let responseOK = response && response.status === 200;

      if (responseOK) {
        const data = await response.data;
        dispatch(addTrendingMovies(data.results));
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    !trendingMovies && getTrendingAll();
  }, []);
};

export default useTrendingMovies;
